import {Button, Modal, ModalContent, ModalFooter, ModalTitle} from '@hm/fundamental'
import {mdiWindowClose, mdiPlus} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {useRefraModal} from '@refra/modules/common/providers'

interface AddKilnShutdownConfirmationModalProps {
  onCloseCallback: () => void
  onConfirmCallback: () => void
}

export const AddKilnShutdownConfirmationModal: React.FC<AddKilnShutdownConfirmationModalProps> = ({
  onCloseCallback,
  onConfirmCallback
}) => {
  const {t} = useTranslation()
  const {closeModal} = useRefraModal()

  const onClose = () => {
    onCloseCallback()
    closeModal()
  }

  const onConfirm = () => {
    onConfirmCallback()
    closeModal()
  }

  return (
    <Modal open onClose={onClose} data-cy="add_shutdown_modal">
      <ModalTitle data-cy="add_shutdown_modal_title">
        {t('refraPlanning.kilnShutdown.newShutdown')}
      </ModalTitle>
      <ModalContent data-cy="add_shutdown_modal_content">
        {t('refraPlanning.kilnShutdown.newShutdownConfirmation')}
      </ModalContent>
      <ModalFooter>
        <Button
          icon={mdiWindowClose}
          variant="secondary"
          onClick={onClose}
          data-cy="add_shutdown_modal_cancel_button"
        >
          {t('common.cancel')}
        </Button>
        <Button icon={mdiPlus} onClick={onConfirm} data-cy="add_shutdown_modal_create_button">
          {t('refraPlanning.kilnShutdown.createShutdown')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
